import { useMemo } from 'react';

const useErrorCodeTrackingCode = () => {
  const ERROR_CODE_TRACKING_CODE = useMemo(() => {
    return {
      '400_VALIDATION_ERROR': {
        message: '400_VALIDATION_ERROR',
        statusCode: 400,
        type: 'error',
      },
      '400_INVALID_FIELD': {
        message: '400_INVALID_FIELD',
        statusCode: 400,
        type: 'error',
      },
      '404_TRACKING_CODE_NOT_FOUND': {
        message: '404_TRACKING_CODE_NOT_FOUND',
        statusCode: 400,
        type: 'error',
      },
      '400_ARGUMENT_IS_NOT_VALID': {
        message: '400_ARGUMENT_IS_NOT_VALID',
        statusCode: 400,
        type: 'error',
      },
      '400_TRACKING_CODE_IDS_CANNOT_BE_NULL_OR_EMPTY': {
        message: '400_TRACKING_CODE_IDS_CANNOT_BE_NULL_OR_EMPTY',
        statusCode: 400,
        type: 'error',
      },
    };
  }, []);
  return {
    ERROR_CODE_TRACKING_CODE,
  };
};

export default useErrorCodeTrackingCode;
